<!-- HomeLenders.vue -->
<template>
  <div class="home-lenders"
    :class="[deviceType === 'mobile' ? 'detect_deviece_mobile' : 'detect_deviece_pc']">
    <div class="lenders-header">
      <div class="header-title">Auto Loan Lenders</div>
      <div class="header-desc">Find the best auto loan options tailored to your needs with our
        trusted lenders.</div>
      <a :href="getPageUrl('/all-lenders')" class="view-all-btn">
        <span>View All Lenders</span>
        <img src="@/assets/icons/arrow-right.svg" alt="Arrow right" class="arrow-icon" />
      </a>
    </div>
    <div class="lenders-cards-container">
      <!-- PC端/非mobile端原有结构 -->
      <div v-if="deviceType !== 'mobile'" class="lenders-cards"
        :style="{ transform: `translateX(-${currentPage * 100}%)` }">
        <div v-for="(group, groupIndex) in lenderGroups" :key="groupIndex" class="lenders-group">
          <a v-for="(lender, index) in group" :key="index" class="lender-card"
            :href="getLenderDetailsUrl(lender)">
            <div class="lender-logo-container">
              <div class="lender-logo">
                <img :src="lender.logoUrl" alt="Lender logo" class="lender-logo" />
              </div>
              <div class="lender-info">
                <div class="lender-name">{{ lender.name || lender.lender }}</div>
                <div class="lender-rating">
                  <img src="@/assets/icons/star.svg" alt="Rating" class="star-icon" />
                  <span>{{ lender.rating || (lender.rate ? parseFloat(lender.rate).toFixed(1) : '4.5') }}</span>
                </div>
              </div>
            </div>
            <div class="divider"></div>
            <div class="lender-details">
              <div class="detail-item">
                <div class="detail-icon apr-icon">
                  <img src="@/assets/icons/apr.svg" alt="APR" />
                </div>
                <div class="detail-content">
                  <div class="detail-label">APR from</div>
                  <div class="detail-value">{{ lender.apr || lender.aprFrom }}</div>
                </div>
              </div>
              <div class="detail-item">
                <div class="detail-icon term-icon">
                  <img src="@/assets/icons/term.svg" alt="Term" />
                </div>
                <div class="detail-content">
                  <div class="detail-label">Loan term</div>
                  <div class="detail-value">{{ lender.term || `${lender.loanTerm } mos` }}
                  </div>
                </div>
              </div>
              <div class="detail-item">
                <div class="detail-icon amount-icon">
                  <img src="@/assets/icons/amount.svg" alt="Amount" />
                </div>
                <div class="detail-content">
                  <div class="detail-label">Loan amount</div>
                  <div class="detail-value">
                    {{ lender.amount || `$${lender.loanAmount }` }}</div>
                </div>
              </div>
            </div>
          </a>
        </div>
      </div>
      <div class="navigation-controls" v-if="deviceType !== 'mobile'">
        <div class="nav-button prev" @click="prevPage" :class="{ 'disabled': currentPage === 0 }">
          <img src="@/assets/icons/arrow-left.svg" alt="Previous" />
        </div>
        <div class="pagination-dots">
          <div v-for="(_, index) in lenderGroups" :key="index" class="pagination-dot"
            :class="{ 'active': index === currentPage }" @click="goToPage(index)">
          </div>
        </div>
        <div class="nav-button next" @click="nextPage"
          :class="{ 'disabled': currentPage === lenderGroups.length - 1 }">
          <img src="@/assets/icons/arrow-right-small.svg" alt="Next" />
        </div>
      </div>
      <!-- mobile端独立横滑结构 -->
      <div v-else class="lenders-cards-mobile-scroll">
        <div class="lenders-group" ref="lendersScroll">
          <a v-for="lender in displayLenders" :key="lender.id" class="lender-card"
            :href="getLenderDetailsUrl(lender)">
            <div class="lender-logo-container">
              <div class="lender-logo">
                <img :src="lender.logoUrl" alt="Lender logo" class="lender-logo" />
              </div>
              <div class="lender-info">
                <div class="lender-name">{{ lender.name || lender.lender }}</div>
                <div class="lender-rating">
                  <img src="@/assets/icons/star.svg" alt="Rating" class="star-icon" />
                  <span>{{ lender.rating || (lender.rate ? parseFloat(lender.rate).toFixed(1) : '4.5') }}</span>
                </div>
              </div>
            </div>
            <div class="divider"></div>
            <div class="lender-details">
              <div class="detail-item">
                <div class="detail-icon apr-icon">
                  <img src="@/assets/icons/apr.svg" alt="APR" />
                </div>
                <div class="detail-content">
                  <div class="detail-label">APR from</div>
                  <div class="detail-value">{{ lender.apr || lender.aprFrom }}</div>
                </div>
              </div>
              <div class="detail-item">
                <div class="detail-icon term-icon">
                  <img src="@/assets/icons/term.svg" alt="Term" />
                </div>
                <div class="detail-content">
                  <div class="detail-label">Loan term</div>
                  <div class="detail-value">{{ lender.term || `${lender.loanTerm } mos` }}
                  </div>
                </div>
              </div>
              <div class="detail-item">
                <div class="detail-icon amount-icon">
                  <img src="@/assets/icons/amount.svg" alt="Amount" />
                </div>
                <div class="detail-content">
                  <div class="detail-label">Loan amount</div>
                  <div class="detail-value">
                    {{ lender.amount || `$${lender.loanAmount }` }}</div>
                </div>
              </div>
            </div>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'HomeLenders',
  data () {
    return {
      currentPage: 0,
      lendersList: []
    }
  },
  computed: {
    ...mapGetters([
      'deviceType',
      'glossary'
    ]),
    displayLenders () {
      // 如果有API返回的数据，优先使用，否则使用默认数据
      return this.glossary && this.glossary.length > 0 ? this.glossary.slice(0, 6) : this.lendersList
    },
    lenderGroups () {
      const lenders = this.displayLenders
      let groups = [];
      for (let i = 0; i < lenders.length; i += 3) {
        groups.push(lenders.slice(i, i + 3));
      }
      return groups;
    }
  },
  methods: {
    prevPage () {
      if (this.currentPage > 0) {
        this.currentPage--;
      }
    },
    nextPage () {
      if (this.currentPage < this.lenderGroups.length - 1) {
        this.currentPage++;
      }
    },
    goToPage (index) {
      this.currentPage = index;
    },
    getLenderDetailsUrl (lender) {
      const lenderName = (lender.name || lender.lender || '').toLowerCase().replace(/\s+/g, '-');
      const id = lender.id || '1'; // Ensure there's a fallback for id
      const path = `/lenders/${lenderName}/${id}`;
      return this.getPageUrl(path);
    },
    // 通用导航方法
    getPageUrl (path) {
      if (this.$route.params.channel) {
        return `/${this.$route.params.channel}${path}`;
      }
      return path;
    }
  }
}
</script>

<style lang="scss" >
@import '~@/css/variables.scss';

.home-lenders {
	padding: rem(60) rem(120);
	position: relative;
	a {
		text-decoration: none;
	}

	&.detect_deviece_mobile {
		padding: 0 0 0 rem(20);
	}

	.lenders-header {
		display: flex;
		flex-direction: column;
		align-items: center;
		margin-bottom: rem(40);
		text-align: center;

		.detect_deviece_mobile & {
			margin-bottom: rem(30);
			padding-right: rem(20);
		}
	}

	.header-title {
		color: #1a4048;
		font-size: rem(32);
		line-height: rem(36);
		font-weight: 900;
		margin-bottom: rem(16);

		.detect_deviece_mobile & {
			font-size: rem(24);
			line-height: rem(28);
			margin-bottom: rem(12);
		}
	}

	.header-desc {
		color: #1a4048;
		font-size: rem(16);
		line-height: rem(20);
		font-weight: 400;
		max-width: rem(700);
		margin-bottom: rem(24);

		.detect_deviece_mobile & {
			font-size: rem(14);
			line-height: rem(18);
			margin-bottom: rem(20);
		}
	}

	.view-all-btn {
		background-color: var(--theme-primary);
		border-radius: rem(100);
		padding: rem(12) rem(24);
		display: flex;
		align-items: center;
		justify-content: center;
		gap: rem(12);
		cursor: pointer;
		transition: opacity 0.3s ease;

		&:hover {
			opacity: 0.7;
		}

		span {
			color: #ffffff;
			font-size: rem(16);
			line-height: rem(16);
			font-weight: 700;
		}

		.arrow-icon {
			width: rem(16);
			height: rem(12);
			color: #ffffff;
		}
	}

	.lenders-cards-container {
		position: relative;
		overflow: hidden;
	}

	.lenders-cards {
		display: flex;
		transition: transform 0.5s ease;
	}

	.lenders-group {
		display: flex;
		justify-content: space-between;
		gap: rem(20);
		min-width: 100%;

		.detect_deviece_mobile & {
			overflow: auto;
			display: flex;
			flex-direction: row;
			gap: rem(16);
			flex-wrap: nowrap;
			&::-webkit-scrollbar {
				display: none;
			}
		}
	}

	.lender-card {
		border-radius: 24px;
		border: 1px solid #e5e7eb;
		background: linear-gradient(180deg, var(--theme-primary-light) 0%, rgba(255, 255, 255, 0) 50%, rgba(255, 255, 255, 0) 100%);
		padding: rem(20);
		width: calc(33.33% - rem(14));
		cursor: pointer;

		&:hover {
			border: rem(2) solid #1a4048;
		}

		.detect_deviece_mobile & {
			width: rem(320);
			flex-shrink: 0;
		}
	}

	.lender-logo-container {
		display: flex;
		flex-direction: row;
		align-items: center;
		margin-bottom: rem(24);
		gap: rem(12);
		.detect_deviece_mobile & {
			margin-bottom: rem(20);
			gap: rem(20);
		}
	}

	.lender-logo {
		width: rem(80);
		height: rem(80);
		border-radius: rem(16);
		background: #ffffff;
		border: rem(1) solid #e6f6f9;
		display: flex;
		align-items: center;
		justify-content: center;
		margin-bottom: 0;
		flex-shrink: 0;
	}

	.logo-placeholder {
		width: rem(60);
		height: rem(60);
		border-radius: rem(8);
		background: #cccccc;
	}

	.lender-info {
		display: flex;
		flex-direction: column;
	}

	.lender-name {
		color: #1a4048;
		font-size: rem(24);
		line-height: rem(28);
		font-weight: 700;
		margin-bottom: rem(8);
		.detect_deviece_mobile & {
			margin-bottom: rem(16);
		}
	}

	.lender-rating {
		display: flex;
		align-items: center;
		gap: rem(4);
		background: #f6c33f;
		border-radius: rem(100);
		padding: rem(4) rem(12);
		width: fit-content;

		.star-icon {
			width: rem(12);
			height: rem(12);
			color: #ffffff;
		}

		span {
			color: #fff;
			font-size: rem(14);
			line-height: rem(14);
			font-weight: 700;
		}
	}

	.divider {
		height: rem(1);
		margin: 0 0 rem(24);
		background: #e5e7eb;
		.detect_deviece_mobile & {
			margin-bottom: rem(20);
		}
	}

	.lender-details {
		display: flex;
		flex-direction: column;
		gap: rem(16);
		.detect_deviece_mobile & {
			gap: rem(24);
		}
	}

	.detail-item {
		display: flex;
		align-items: center;
		gap: rem(12);
	}

	.detail-icon {
		width: rem(44);
		height: rem(44);
		border-radius: rem(100);
		background: var(--theme-primary);
		display: flex;
		align-items: center;
		justify-content: center;

		img {
			width: rem(24);
			height: rem(24);
			flex-shrink: 0;
			color: #ffffff;
		}
	}

	.detail-content {
		display: flex;
		flex-direction: column;
	}

	.detail-label {
		color: #1a4048;
		font-size: rem(14);
		line-height: rem(16);
		font-weight: 400;
		margin-bottom: rem(4);
		.detect_deviece_mobile & {
			margin-bottom: rem(8);
		}
	}

	.detail-value {
		color: #1a4048;
		font-size: rem(16);
		line-height: rem(20);
		font-weight: 700;
		.detect_deviece_mobile & {
			font-size: rem(20);
		}
	}

	.navigation-controls {
		display: flex;
		justify-content: center;
		align-items: center;
		margin-top: rem(40);
		gap: rem(20);
	}

	.nav-button {
		width: rem(28);
		height: rem(28);
		border-radius: rem(100);
		background: #1a4048;
		display: flex;
		align-items: center;
		justify-content: center;
		cursor: pointer;
		transition: background-color 0.3s ease;

		img {
			width: rem(6);
			height: rem(12);
			color: #ffffff;
		}

		&:hover {
			background-color: var(--theme-primary);

			img {
				color: #ffffff;
			}
		}

		&.disabled {
			opacity: 0.5;
			cursor: not-allowed;

			&:hover {
				background: #1a4048;

				img {
					color: #ffffff;
				}
			}
		}
	}

	.pagination-dots {
		display: flex;
		gap: rem(8);
	}

	.pagination-dot {
		width: rem(8);
		height: rem(8);
		border-radius: 50%;
		background: #e6f6f9;
		cursor: pointer;
		transition: background-color 0.3s ease;

		&.active {
			background: #1a4048;
		}

		&:hover:not(.active) {
			background: #66cee4;
		}
	}

	.detect_deviece_mobile {
		.lenders-cards-mobile-scroll {
			overflow-x: auto;
			padding: 0 0 0 rem(16);
			-webkit-overflow-scrolling: touch;
			scrollbar-width: none;
			&::-webkit-scrollbar {
				display: none;
			}
		}
		.lenders-cards-mobile {
			display: flex;
			flex-direction: row;
			gap: rem(16);
			width: 100%;
			flex-wrap: nowrap;
		}
		.lender-card-mobile {
			min-width: rem(320);
			max-width: rem(320);
			flex: 0 0 rem(320);
			border-radius: rem(24);
			padding: rem(24);
			background: linear-gradient(180deg, var(--theme-primary-light) 0%, rgba(255, 255, 255, 0) 50%, rgba(255, 255, 255, 0) 100%);
			border: rem(1) solid #e5e7eb;
			box-sizing: border-box;
		}
	}
}
</style> 